import React from 'react';
import { FileCheck2Icon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
export function ConditionsSection() {
  return <section aria-labelledby="condiciones" className="bg-white text-brand-petrol" data-id="element-42" data-mp="2oi86sgvc9to4">
      <div className="mx-auto max-w-xl px-3 py-4 sm:px-5" data-id="element-43" data-mp="2si8ocadqikze">
        <Reveal className="flex items-start gap-3 rounded-2xl border-2 border-brand-emerald bg-brand-ivory p-3 text-left" data-id="element-44" data-mp="2xid05n3p6rja">
          <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-brand-emerald" data-id="element-45" data-mp="32i96vu3s4x2j">
            <FileCheck2Icon size={20} className="text-white" data-id="element-46" data-mp="37f9e48cd85v8" />
          </span>
          <div data-id="element-47" data-mp="3c70ujq1t4v7n">
            <h2 id="condiciones" className="font-sub text-sm font-bold uppercase leading-tight sm:text-base" data-id="element-48" data-mp="3c8kcdl343ebj">
              Conocé las condiciones antes de comprar
            </h2>
            <p className="mt-0.5 text-xs leading-snug text-brand-muted sm:text-sm" data-id="element-49" data-mp="3l9sao35mof5m">
              Consultá el proceso de entrega, los medios de pago y las
              condiciones de devolución aplicables.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}